import "../../scss/client/client.scss";

/* ------------------------------- COMPONENTS ------------------------------- */
import "./components/photoswipe";
import "./components/carrousel";
import "./components/slider";
import "./components/modal";
import "./components/svg-lazy";
import "./components/wp-block-table";
import "./components/accordion";
import "./components/select2";
import "./components/video-player";
import "./components/faq";

/* --------------------------------- SCRIPTS -------------------------------- */
import "./scripts/navigation";
import "./scripts/search";
import "./scripts/post-list";
import './scripts/event-insight-main';
import "./scripts/event-list";
import './scripts/event-list-main'
import './scripts/event-table-main'
import './scripts/event-detail'
import "./scripts/page";
import "./scripts/area-insight";
import "./scripts/about";
import "./scripts/study-program-search";
import './scripts/study-program-detail';
import "./scripts/study-program-info-block";
import "./scripts/cookies";
import "./scripts/habilitations";
import "./scripts/datepicker";
import "./scripts/event-form";
import "./scripts/back-button";
import "./scripts/employee-info";
import "./scripts/document-folder";
import "./scripts/form";

/* ---------------------------------- UTILS --------------------------------- */
import "./utils/smoothscroll";
import "./utils/events";
import "./utils/inject-css";

/* ---------------------------------- REACT --------------------------------- */

export const componentsToRender = [];

componentsToRender.forEach(({ Component, dataType }) => {
  const componentWrappers = document.querySelectorAll(
    `[data-type="${dataType}"]`
  );

  componentWrappers.length &&
    componentWrappers.forEach((wrapper) => {
      const props = JSON.parse(wrapper.getAttribute("data-props"));
      const ComponentToRender = React.cloneElement(Component, props);
      ReactDOM.render(ComponentToRender, wrapper);
    });
});
